module.exports = __webpack_public_path__ + "assets/6d3412a1b6cb4c377b976dc238edad43.mp3";